import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  StorageAuditFinding,
  StorageAuditFindingFilters,
  StorageAuditPaginatedResponse,
  StorageAuditRun,
} from "~/types/admin/storageAudit";

class AdminStorageAuditModule extends HttpFactory {
  async createRun(): Promise<StorageAuditRun> {
    return await this.post(ENDPOINTS.ADMIN.BASE.STORAGE_AUDIT.RUNS, {});
  }

  async getRun(runId: number): Promise<StorageAuditRun> {
    return await this.get(
      `${ENDPOINTS.ADMIN.BASE.STORAGE_AUDIT.RUNS}${runId}/`,
    );
  }

  async getFindings(
    filters: StorageAuditFindingFilters = {},
  ): Promise<StorageAuditPaginatedResponse<StorageAuditFinding>> {
    return await this.get(ENDPOINTS.ADMIN.BASE.STORAGE_AUDIT.FINDINGS, filters);
  }

  async ignoreFinding(findingId: number): Promise<StorageAuditFinding> {
    return await this.post(
      `${ENDPOINTS.ADMIN.BASE.STORAGE_AUDIT.FINDINGS}${findingId}/ignore/`,
      {},
    );
  }

  async deleteObject(findingId: number): Promise<StorageAuditFinding> {
    return await this.post(
      `${ENDPOINTS.ADMIN.BASE.STORAGE_AUDIT.FINDINGS}${findingId}/delete-object/`,
      {},
    );
  }
}

export default AdminStorageAuditModule;
